import React, { useEffect, useState } from "react";
import AllProjects from "./All";
import * as Cesium from 'cesium';
import { showAlert } from "helper";
import AddAssets from "./AddAssets";
import CreateProject from "./Create";
import SingleProject from "./Single";
import LocalUpload from "./LocalUpload";
import Collections from "./Collections";
import VirtualTour from "./VirtualTour";
import EditAnnotation from "./EditAnnotation";
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import modelImg from "./AddAssets/images/3d-model.png";
import terrainImg from "./AddAssets/images/terrain.png";
import imageryImg from "./AddAssets/images/imagery.png";
import WebMapServicesUpload from "./WebMapServicesUpload";
import useViewerStore from '../../../store-zustand/viewer';
import useProjectStore from '../../../store-zustand/project';
import CollectionDetail from "./Collections/CollectionDetail";
import { ClearGlobalVariables } from '../../MapView/MapUtils';
import pointCloudImg from "./AddAssets/images/point-cloud.png";
import demandTaskingImg from "./AddAssets/images/demand-tasking.png"

const Panels = {
  All: "All",
  Create: "Create",
  Single: "Single",
  EditAnnotation: "EditAnnotation",
  AddAsset: "AddAsset",
  LocalUpload: "LocalUpload",
  WebMapServicesUpload: "WebMapServicesUpload",
  Collections: "Collections",
  CollectionDetail: "CollectionDetail",
  EditAsset: "EditAsset",
  VirtualTour: "VirtualTour",
};

const assetsTypes = [
  { id: 1, label: '3D Tiles', bg: pointCloudImg },
  { id: 2, label: 'Imagery', bg: imageryImg },
  { id: 3, label: '3D Model', bg: modelImg },
  { id: 4, label: 'Terrain', bg: terrainImg },
  { id: 5, label: 'Points, Lines & Polygons', bg: demandTaskingImg },
];

const serviceTypes = [
  { id: 1, label: 'Point Cloud' },
  { id: 2, label: 'Imagery' },
  { id: 3, label: '3D Model' },
  { id: 4, label: 'Terrain' }
]

const SidebarProjects = ({ onClose }) => {
  const { project_id: project } = useProjectStore();
  const [isCreateProject, setIsCreateProject] = useState(false);
  const { viewer, setmapboxvisibility, showmapModal } = useViewerStore();
  const currentCollection = useSelector(state => state.asset.currentCollection);
  const selectedIonAsset = useSelector(state => state.asset.selectedIonAsset);
  const [selectedType, setSelectedType] = useState();
  const panel = useSelector(state => state.project.panel);
  const editingAnnotation = useSelector(state => state.settings.editingAnnotation);
  const dispatch = useDispatch();
  const history = useHistory();
  const [mapmodal, setModal] = useState({});
  const { project_modal_information: project_data, setsingleannotationeidtion, setproject_id, getprojectdataByid, gettypedataById, setproject_modal_information, setselectedCategory, setselectedCategoryColor, setselectedCategoryPK, removeannotation, setreloadAnnotationsList, project_id } = useProjectStore();

  useEffect(() => {
    if (project && (panel == Panels.All || !panel)) {
      handleSingleProject();
    }
  }, [project])

  const handleEditAnnotation = (annotation) => {
    setsingleannotationeidtion(undefined);
    dispatch({ "type": "SET_SELECTED_EDITING_ANNOTATION", editingAnnotation: annotation })
    dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.EditAnnotation });
    let clearannotations = false;
    ClearGlobalVariables(viewer, clearannotations);
    document.getElementById("cesium-wrapper").style.cursor = 'default';
  };

  const handleCloseAnnoation = () => {
    dispatch({ type: 'TOGGLE_MEASUREMENT_ENABLE', show: true });
    dispatch({ type: 'TOGGLE_PIN_ENABLE', show: true });
    dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.Single });
    dispatch({ "type": "SET_SELECTED_EDITING_ANNOTATION", editingAnnotation: null })

    if (window.handlerDrawPointGeom) {
      window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      delete (window.handlerDrawPointGeom);
    }
    
    if (window.handlerEditPolygonGeom) {
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
      delete (window.handlerEditPolygonGeom);
    }

    ClearGlobalVariables(viewer);
    document.getElementById("cesium-wrapper").style.cursor = 'default';
  };

  const completeCreateStatus = () => {
    setIsCreateProject(false);
  }

  const handleSingleProject = (params) => {
    if (params === 'direct-edit') {
      setIsCreateProject(true);
    } else {
      setIsCreateProject(false);
    }

    if (!project_id) return
    async function fetchData() {
      const project_info = await getprojectdataByid(project_id);
      if (project_info !== undefined && project_info !== "Error") {
        const typeData = await gettypedataById(project_info[0].fields?.type);
        setselectedCategory(typeData[0].fields?.TYPENAME);
        setselectedCategoryColor(typeData[0].fields?.COLOR);
        setselectedCategoryPK(typeData[0].pk);
        
        let BBOXData = project_info[0].fields?.BBOX.replaceAll("[", "");
        BBOXData = BBOXData?.replaceAll("]", "");
        BBOXData = BBOXData?.replaceAll("'", "");
        let rectangle = BBOXData?.split(",");
        rectangle && viewer && (
          viewer.camera.flyTo({
            destination: Cesium.Rectangle.fromDegrees(parseFloat(rectangle[0]), parseFloat(rectangle[2]), parseFloat(rectangle[1]), parseFloat(rectangle[3]))
          })
        );
        let location_string = `${project_info[0].fields?.ADDRESS}, ${project_info[0].fields?.REGION} ${project_info[0].fields?.POSTAL}, ${project_info[0].fields?.COUNTRY}`;
        if (location_string.length > 40) {
          location_string = location_string.substring(0, 37);
          location_string = `${location_string} ...`;
        }

        setproject_modal_information({
          info: {
            address: project_info[0].fields?.ADDRESS,
            place_name: project_info[0].fields?.ADDRESS,
            postal_code: project_info[0].fields?.POSTAL,
            region: project_info[0].fields?.REGION,
            country: project_info[0].fields?.COUNTRY,
            description: project_info[0].fields?.DESCRIPTION,
            temperature: project_info[0].fields?.TEMPERATURE,
            location: location_string,
            projectname: project_info[0].fields?.NAME,
            created: project_info[0].fields?.CREATED,
            updated: project_info[0].fields?.UPDATED
          }
        });
      } else {
        console.log("fetchData: Project not found")
      }
    }

    fetchData();
    dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.Single });
    dispatch({ type: 'TOGGLE_MAP_TOOL', show: true });
    dispatch({ type: 'TOGGLE_DATE_PAGINATOR', show: true });
  }

  const handleCollectionDetail = (collection) => {
    dispatch({ type: "SET_CURRENT_COLLECTION", currentCollection: collection });
    dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.CollectionDetail });
    dispatch({ type: 'TOGGLE_DATA_DOWNLOAD_MODAL', show: true });
  }

  const onLocalUpload = (type) => {
    setSelectedType(type);
    dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.LocalUpload });
  }

  const onVirtualTour = () => {
    dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.VirtualTour });
  }

  const handleAnnotationDelete = async (annotationItem) => {
    let ID = annotationItem.annotationId;
    let keyword = {};
    keyword.IDANNOTATION = ID;
    let annotationREmovedId = await removeannotation(keyword);
    let removedpolygonoutline = viewer.entities.getById(`${ID}PolygonOutline`);
    if (Cesium.defined(removedpolygonoutline)) {
      viewer.entities.remove(removedpolygonoutline);
    }

    if (annotationREmovedId !== 'Error') {
      showAlert('success', 'Annotation removed successfully!')
      setreloadAnnotationsList(annotationREmovedId);
    } else {
      showAlert('error', 'An error occured while removing the Annotation.')
    }
  };

  switch (panel) {
    case Panels.All:
      dispatch({ type: 'TOGGLE_MAP_TOOL', show: false });
      dispatch({ type: 'TOGGLE_DATE_PAGINATOR', show: false });
      return (<AllProjects handleSingleProject={handleSingleProject} onClose={onClose} returnAllProjectsPage={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.All })} />);
    
    case Panels.Create:
      return (<CreateProject handleCreateProject={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.Single })} onClose={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.All })} />);
    
    case Panels.Single:
      return (
        <SingleProject
          onBack={() => {
            setproject_id(null);
            setmapboxvisibility(0);
            dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.All });
            dispatch({ type: "TOGGLE_COMPARE_TOOL", compareTool: false });
            history.push("/projects");
            var iframeElem = document.getElementById("matterport-iframe");
            iframeElem.src = null;
            iframeElem.style.display = "none";
          }}
          onClose={onClose}
          onEditAnnotation={handleEditAnnotation}
          onAddAsset={(modaldata) => {
            setModal(modaldata);
            dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.AddAsset });
            setmapboxvisibility(0);
            dispatch({ type: 'TOGGLE_EXPORT_MODAL', show: false });
          }}
          onEditAsset={() => { dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.EditAsset })}}
          completeCreateStatus={completeCreateStatus}
          isCreate={isCreateProject}
          onMarketPlace={() => { setmapboxvisibility(0); dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.Collections }); }}
        />
      );
    
    case Panels.EditAnnotation:
      return (
        <EditAnnotation
          onClose={onClose}
          onBack={() => {
            handleCloseAnnoation();
          }}
          onDelete={() => {
            handleAnnotationDelete(editingAnnotation);
            handleCloseAnnoation();
          }}
          annotation={editingAnnotation}
          closeeditedannotation={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.Single })}
        />
      );
    
    case Panels.AddAsset:
      return <>
        <AddAssets
          onClose={onClose}
          onBack={() => { dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.Single }) }}
          onLocalUpload={onLocalUpload}
          onVirtualTour={onVirtualTour}
          types={assetsTypes}
          onShowCollections={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.Collections })} />
      </>;
    
    case Panels.EditAsset:
      if (selectedIonAsset.type == "MATTERPORT") {
        return <VirtualTour onClose={onClose} onBack={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.AddAsset })} types={assetsTypes} selectedType={selectedType} />
      } else {
        return <>
          <LocalUpload onClose={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.AddAsset })} types={assetsTypes}
            selectedType={
              selectedIonAsset ?
                selectedIonAsset.type === "3DTILES" ? assetsTypes[0] :
                  selectedIonAsset.type === "IMAGERY" ? assetsTypes[1] :
                    selectedIonAsset.type === "GLTF" ? assetsTypes[2] :
                      selectedIonAsset.type === "TERRAIN" ? assetsTypes[3] :
                        assetsTypes[4]
                : null
            }
            onBack={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.AddAsset })} />
        </>
      }
    
    case Panels.LocalUpload:
      return <LocalUpload onClose={onClose} onBack={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.AddAsset })} types={assetsTypes} selectedType={selectedType} />;
    
    case Panels.VirtualTour:
      return <VirtualTour onClose={onClose} onBack={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.AddAsset })} types={assetsTypes} selectedType={selectedType} />;
    
    case Panels.WebMapServicesUpload:
      return <WebMapServicesUpload onClose={onClose} onBack={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.AddAsset })} types={serviceTypes} />;
    
    case Panels.Collections:
      return <Collections onClose={onClose} onBack={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.Single })} goToDetailPage={handleCollectionDetail} />;
    
    case Panels.CollectionDetail:
      return <CollectionDetail onClose={onClose} onBack={() => dispatch({ type: 'SET_PROJECT_PANEL', panel: Panels.Collections })} collection={currentCollection} />;
    
    default:
      return <></>;
  }
};

export default SidebarProjects;